import { ScrapingControls } from "@/components/scraping/ScrapingControls";
import { ScrapingHeader } from "@/components/scraping/ScrapingHeader";
import { LiveLogTree } from "@/components/ui/LiveLogTree/LiveLogTree";
import { useScraping } from "@/hooks/useScraping";
import * as shared from "@/styles/shared";
import * as styles from "./ScrapingPage.styles";

const ScrapingPage = () => {
  const scrape = useScraping();

  return (
    <div className={shared.pageFill}>
      <ScrapingHeader onBack={() => scrape.navigate(-1)} onClearLogs={scrape.handleClearLogs} hasLogs={!!scrape.rawLogs.length} />
      <div className={styles.body}>
        <ScrapingControls scraping={scrape.scraping} onScrape={scrape.handleStartScraping} />
        <div className={styles.logAreaWrapper}>
          <div className={styles.logArea}>
            <LiveLogTree initialAddresses={scrape.initialAddresses} rawLogs={scrape.rawLogs} />
            <div ref={scrape.logsEndRef} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScrapingPage;
